const getters = {
  sidebar: (state) => state.app.sidebar,
  size: (state) => state.app.size,
  toolbar: (state) => state.app.toolbar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  realName: (state) => state.user.realName,
  introduction: (state) => state.user.introduction,
  roles: (state) => state.user.roles,
  permissions: (state) => state.user.permissions,
  permission_routes: (state) => state.permission.routes,
  topbarRouters: (state) => state.permission.topbarRouters,
  defaultRoutes: (state) => state.permission.defaultRoutes,
  sidebarRouters: (state) => state.permission.sidebarRouters,
  dept: (state) => state.user.dept,
  userinfo: (state) => state.user.userinfo,
  navmenu: (state) => state.user.navmenu,
  roleType: state => state.user.roleType,
  classId: state => state.user.classId,
  classLists: state => state.user.classLists,
  messageInfo: state => state.message.messageInfo,
  userInfo: state=>state.user.userInfo,
  viewLocate: state=>state.user.viewLocate,
}
export default getters
